<template>
  <div class="mgb-20">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="(item, index) in breadList"
        :key="index"
        :to="{ path: item.path }"
      >
        <i v-if="index == 0" class="el-icon-s-home"></i>
        {{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  // name: "breadcrumbs",
  data() {
    return {
      breadList: [],
    };
  },
  mounted() {
    // if (this.$route.matched[1].path == "/zoneManage/zoneInfo") {
    //   this.$route.matched.splice(1, 0, {
    //     name: "不晓得什么分区 ",
    //     path: this.$route.matched[0].path,
    //   });
    // }
    this.breadList = this.$route.matched;
  },
};
</script>

<style scoped lang="scss">
/* 面包屑：element-theme 未纳入 el-breadcrumb，故在本组件 scoped 块内主题化 */
::v-deep .el-breadcrumb {
  font-size: 14px;
  line-height: 1;
}
::v-deep .el-breadcrumb__inner,
::v-deep .el-breadcrumb__inner.is-link {
  color: var(--text-muted);
  font-weight: 500;
  transition: color 0.2s ease;
}
::v-deep .el-breadcrumb__inner.is-link:hover {
  color: var(--accent);
}
::v-deep .el-breadcrumb__separator {
  color: var(--text-muted);
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: var(--text-main);
  cursor: default;
}
::v-deep .el-icon-s-home {
  margin-right: 4px;
  color: var(--accent);
}
</style>
